import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=2b9cb3d4&scoped=true&"
import script from "./EmailInput.vue?vue&type=script&lang=js&"
export * from "./EmailInput.vue?vue&type=script&lang=js&"
import style0 from "./EmailInput.vue?vue&type=style&index=0&id=2b9cb3d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9cb3d4",
  null
  
)

export default component.exports